import React, { useEffect } from 'react';
import HistogramStartPhoto from '../images/HistogramStart.png';
import HistogramBarTimePhoto from '../images/HistogramBarTime.png';
import HistogramRangeSliderPhoto from '../images/HistogramRangeSlider.png';
import HistogramFilterPhoto from '../images/HistogramFilter.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const SeismicEventPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Microseismic Events Histogram and Filter
        </div>
        <div style={{ margin: '10px 0px' }}>
        When Microseismic Events added to the project, Microseismic Events Histogram will be shown in the bottom panel under the view. 
        The default sampling time is 30 minutes. To change sampling time, select radio button:
        <div>
          <input type="radio" id="html" name="fav_language" value="HTML" /> 30 minutes 
          <input type="radio" id="html" name="fav_language" value="HTML" /> 1 Hour 
          <input type="radio" id="html" name="fav_language" value="HTML" /> 2 Hours
        </div>
        </div>

        <StyledContainer>
            <img src={HistogramStartPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
         When mouse over histogram bar, an info box will popup. It shows bar events' stage name, start time and end time, events count in this time period.
        </div>

        <StyledContainer>
            <img src={HistogramBarTimePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
          Under the histogram, you can change events' start and end time by left clicking the start or end point and moving the mouse. 
          When start or end time changed, Microseismic events in the view will be updated.
        </div>
        <StyledContainer>
            <img src={HistogramRangeSliderPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        There are events filter: Magnitude filter and Confidence filter under histogram. Scroll down Histogram panel, 
        Magnitude filter and Confidence filter will be displayed. Change the minimum and maximun values of Magnitude filter and Confidence filter,
        Microseismic events will be filtered and updated in the view.

        </div>
        <StyledContainer>
            <img src={HistogramFilterPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default SeismicEventPage;